import React, { useEffect, useState } from "react";
import { ModalLoader } from "../../../Components/Atoms/ModalLoader";
import {
  Paper,
  Typography,
  Collapse,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  IconButton,
  Menu,
  MenuItem,
  Box,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  Button,
  Chip,
  Link as MuiLink,
  TableContainer,
} from "@mui/material";

import {
  Edit,
  MoreVert,
  ToggleOn,
  ToggleOff,
  PersonAdd,
} from "@mui/icons-material";

import { Link as RouterLink } from 'react-router-dom'

import { makeStyles } from "@mui/styles";
import { ScreenGreeting } from "../../../Components/Molecules";
import { useToast } from "../../../Hooks/toast";
import { Link, useHistory } from "react-router-dom";
import { FiExternalLink } from "react-icons/fi";
import api from "../../../Services/api";
import CreateOperatorModal from "./CreateOperatorModal";
import Tooltip from "../../../Components/Atoms/Tooltip";


const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    maxWidth: "90%",
    minHeight: "100%",
    margin: "0px auto",
  },
  paper: {
    minWidth: "100%",
    marginBottom: 20,
    marginTop: 20,
    padding: 10,
  },
}));

export const Operators = ({ }) => {
  const classes = useStyles();

  const [operators, setOperators] = useState([]);
  const [openCreate, setOpenCreate] = useState(false);
  const [editingId, setEditingId] = useState(null);

  const getOperators = async () => {
    const { data } = await api.get(`/operators`);
    setOperators(data);
  }

  useEffect(() => {
    getOperators();
  }, []);

  return (
    <>
      <ScreenGreeting
        title="Operadores"
        subTitle="Aqui você poderá realizar a gestão dos seus operadores."
      />

      <Button onClick={() => { setEditingId(null); setOpenCreate(true); }} variant="contained" sx={{ color: 'white' }} startIcon={<PersonAdd />}>
        Adicionar Operador
      </Button>
      <CreateOperatorModal
        open={openCreate}
        operatorId={editingId || undefined}
        onClose={() => { setOpenCreate(false); setEditingId(null); }}
        onSaved={() => { getOperators(); }}
      />
      <Paper className={classes.paper} elevation={3}>
        <OperatorsTableList operators={operators} onEdit={(id) => { setEditingId(id); setOpenCreate(true); }} />
      </Paper>
    </>
  );
};

const TipoUser = {
  admin: "Administrador",
  user: "Usuário",
  subAccount: "Operador",
};

export const OperatorsTableList = ({
  operators,
  isHiddenSubAccountLink,
  onEdit
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  return (
    <TableContainer sx={{ whiteSpace: 'nowrap' }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="left"></TableCell>
            <TableCell align="left">Nome</TableCell>
            <TableCell align="left">E-mail</TableCell>
            <TableCell align="left">Perfil</TableCell>
            {!isHiddenSubAccountLink && (
              <TableCell align="left">Ponto de venda</TableCell>
            )}

            <TableCell align="center">Data de criação</TableCell>
            <TableCell align="center">Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {operators.length === 0 && (
            <TableRow>
              <TableCell align="center" colSpan={10}>
                Nenhum operador foi adicionado
              </TableCell>
            </TableRow>
          )}

          {operators?.map((row, index) => (
            <TableRow key={row.id}>
              <TableCell align="left" width={10}>
                <Tooltip title="Editar operador">
                  <IconButton onClick={() => onEdit?.(row.id)}>
                    <Edit fontSize="inherit" />
                  </IconButton>
                </Tooltip>
              </TableCell>
              <TableCell align="left">{row.name}</TableCell>
              <TableCell align="left">{row.email}</TableCell>
              <TableCell align="left">{TipoUser[row.profile]}</TableCell>
              {!isHiddenSubAccountLink && (
                <TableCell align="center">
                  {row.subAccountId ? (
                    <MuiLink
                      component={Link}
                      to={`/pontos-de-venda/${row.subAccountId}`}
                    >
                      ver ponto de venda <FiExternalLink />
                    </MuiLink>
                  ) : (
                    "---"
                  )}
                </TableCell>
              )}

              <TableCell align="center">
                {new Date(row.createdAt).toLocaleDateString()}
              </TableCell>
              <TableCell align="center">
                {row.isActive ? (
                  <Chip label="Ativo" color="success" />
                ) : (
                  <Chip label="Inativo" color="error" variant="outlined" />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};


